import Vue from 'vue'
import store from 'store'
import qs from 'qs'

export default {
    updateText(rootState, newText, updateRecordId, callbacks)  {
        let defaultFailErrorCallback = function ()  {
            store.commit('ALERT_DATA_UPDATED', {
                text: 'La mise à jour du texte a échoué.',
                type: 'danger'
            });
        };

        let params = qs.stringify({"data": JSON.stringify({
            content: newText.content,
            pronunciation: newText.pronunciation,
            updateRecordId: updateRecordId
        })});

        Vue.axios.post(rootState.baseUrl + "/admin/text/" + newText.id, params, {"headers": rootState.postHeaders}).then((response) => {
            if (response.data.success)  {
                if (callbacks.success)  {
                    callbacks.success(response.data.id);
                }
                return true;
            }
            if (callbacks.fail)  {
                callbacks.fail();
            }
            defaultFailErrorCallback();
            return false;
        }).catch((err) => {
            if (callbacks.error)  {
                callbacks.error();
            }
            defaultFailErrorCallback();
            return false;
        });
    },
    deleteText(rootState, textToDelete, callbacks) {
        let defaultFailErrorCallback = function ()  {
            store.commit('ALERT_DATA_UPDATED', {
                text: "La suppression du texte a échoué.",
                type: 'danger'
            });
        };

        Vue.axios.delete(rootState.baseUrl + "/admin/text/delete/" + textToDelete.id, {"headers": rootState.headers}).then((response) => {
            if (response.data.success)  {
                if (callbacks.success)  {
                    callbacks.success();
                }
                return true;
            }
            if (callbacks.fail)  {
                callbacks.fail();
            }
            defaultFailErrorCallback();
            return false;
        }).catch((err) => {
            if (callbacks.error)  {
                callbacks.error();
            }
            defaultFailErrorCallback();
            return false;
        });
    },
    getText(rootState, textId, callbacks)  {
        let defaultFailErrorCallback = function ()  {
            store.commit('ALERT_DATA_UPDATED', {
                text: 'La récupération du texte a échoué.',
                type: 'danger'
            });
        };

        Vue.axios.get(rootState.baseUrl + "/admin/text/" + textId, {headers: rootState.headers}).then((response) => {
            if (response.data.success)  {
                if (callbacks.success)  {
                    callbacks.success(response.data.text);
                }
                return true;
            }
            if (callbacks.fail)  {
                callbacks.fail();
            }
            defaultFailErrorCallback();
            return false;
        }).catch((err) => {
            if (callbacks.error)  {
                callbacks.error();
            }
            defaultFailErrorCallback();
            return false;
        });
    },
    getTextList(rootState, personId, page, callbacks)  {
        let defaultFailErrorCallback = function ()  {
            store.commit('ALERT_DATA_UPDATED', {
                text: 'La récupération de la liste des textes a échoué.',
                type: 'danger'
            });
        };

        Vue.axios.get(rootState.baseUrl + "/common/person/" + personId + "/texts/" + page, {headers: rootState.headers}).then((response) => {
            if (response.data.success)  {
                if (callbacks.success)  {
                    callbacks.success(response.data);
                }
                return true;
            }
            if (callbacks.fail)  {
                callbacks.fail();
            }
            defaultFailErrorCallback();
            return false;
        }).catch((err) => {
            if (callbacks.error)  {
                callbacks.error();
            }
            defaultFailErrorCallback();
            return false;
        });
    },
    linkPersonToText(rootState, textId, newPerson, callbacks)  {
        let defaultFailErrorCallback = function ()  {
            store.commit('ALERT_DATA_UPDATED', {
                text: "La liaison du personnage avec le texte a échoué.",
                type: 'danger'
            });
        };

        let params = qs.stringify({"data": JSON.stringify({})});
        Vue.axios.post(rootState.baseUrl + "/admin/text/" + textId + "/link-person/" + newPerson.id, params, {"headers": rootState.postHeaders}).then((response) => {
            if (response.data.success)  {
                if (callbacks.success)  {
                    callbacks.success(response.data.id);
                }
                return true;
            }
            if (callbacks.fail)  {
                callbacks.fail();
            }
            defaultFailErrorCallback();
            return false;
        }).catch((err) => {
            if (callbacks.error)  {
                callbacks.error();
            }
            defaultFailErrorCallback();
            return false;
        });
    },
    textToSpeech(rootState, textToSpeechData, callbacks)  {
        let defaultFailErrorCallback = function ()  {
            store.commit('ALERT_DATA_UPDATED', {
                text: 'La génération du fichier son a échoué.',
                type: 'danger'
            });
        };

        let formData = new FormData();
        formData.append("data", JSON.stringify(textToSpeechData));

        Vue.axios.post(rootState.baseUrl + "/common/text/to-speech", formData, {"headers": rootState.postDataHeaders, responseType: 'blob'}).then((response) => {
            let blobUrl = window.URL.createObjectURL(response.data);
            if (callbacks.success)  {
                callbacks.success(blobUrl);
            }
            blobUrl = null;
            return true;
        }).catch((err) => {
            if (callbacks.error)  {
                callbacks.error();
            }
            defaultFailErrorCallback();
            return false;
        });
    },
    generateVoiceForText(rootState, textId, textToSpeechData, callbacks)  {
        let defaultFailErrorCallback = function ()  {
            store.commit('ALERT_DATA_UPDATED', {
                text: 'La génération du fichier son a échoué.',
                type: 'danger'
            });
        };

        let formData = new FormData();
        formData.append("data", JSON.stringify(textToSpeechData));

        Vue.axios.post(rootState.baseUrl + "/admin/text/" + textId + "/generate-voice", formData, {"headers": rootState.postDataHeaders}).then((response) => {
            if (callbacks.success)  {
                callbacks.success(response.data.text);
            }
            return true;
        }).catch((err) => {
            if (callbacks.error)  {
                callbacks.error();
            }
            defaultFailErrorCallback();
            return false;
        });
    }
};